import {
    Container,
    Typography,
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Button,
    Paper,
    Box,
    Snackbar,
    Alert,
    Grid,
    Divider
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import './formGradimento.css';
import { FormGradimentoDTO } from '../../services/FormGradimento/FormGradimentoDTO';
import { formGradimentoService } from '../../services/FormGradimento/FormGradimentoService';
import { useAuth } from '../../contexts/AuthContext';
import { format, parse } from 'date-fns';
import { it } from 'date-fns/locale';

const FormGradimento = () => {

    const { idUtente } = useAuth();

    const [loading, setStatoCaricamento ] = useState(false);
    const [messaggioCaricamento, setMessaggioCaricamento] = useState("");
    
    // Funzione per impostare lo stato di caricamento
    const setCaricamento = (isLoading, messaggio = "") => {
        setStatoCaricamento(isLoading);
        setMessaggioCaricamento(messaggio);
    };

    // Per formattare dal formato backend (ISO) al formato visualizzato
    const formattaData = (dataString) => {
        if (!dataString) return '';
        try {
            return format(new Date(dataString), 'dd/MM/yyyy', { locale: it });
        } catch (e) {
            return '';
        }
    };

    useEffect(() => {
        const caricaDati = async () => {
            try {
                setCaricamento(true);

                // Chiamata al servizio
                const datiRicevuti = await formGradimentoService.caricaDatiIniziali(idUtente);
                
                //console.info('dati:', datiRicevuti);

                // Precompilazione dei campi del form
                setDatiForm({
                    idUtente: idUtente,
                    idSottoProgetto: datiRicevuti.idSottoProgetto || '',
	                idForm: datiRicevuti.idForm || '',
                    
                    nomePartecipante: datiRicevuti.nomeDelPartecipante || '',
                    numeroProgetto: datiRicevuti.numeroProgetto || '',
                    destinazione: datiRicevuti.destinazione || '',
                    dataInizio: formattaData(datiRicevuti.dataInizioPeriodo),
                    dataFine: formattaData(datiRicevuti.dataFinePeriodo),
                    dataValutazioneInizio: formattaData(datiRicevuti.dataValutazionePeriodoA),
                    dataValutazioneFine: new Date().toLocaleDateString(),
                    //...datiForm,
                });

            } catch (errore) {
                console.error('Errore nel caricamento dei dati:', errore);

            } finally {
                setCaricamento(false);
            }
        };

        // Esegui la funzione di caricamento
        caricaDati();

    }, []);

    const navigate = useNavigate();

    const [datiForm, setDatiForm] = useState({

	    idUtente: 0,
	    idSottoProgetto: 0,
	    idForm: 0,

        // Dati personali
        nomePartecipante: '',
        numeroProgetto: '',
        destinazione: '',
        dataInizio: null,
        dataFine: null,
        dataValutazioneInizio: null,
        dataValutazioneFine: null,
        
        // Domande a scelta multipla
        coinvolgimento: '',
        nuoveAbilita: '',
        caricoLavoro: '',
        istruzioniChiare: '',
        orariLavoro: '',
        sistemazione: '',
        posizioneSistemazione: '',
        trasportiLocali: '',
        supportoOrganizzazione: '',
        
        // Domande aperte
        commentiPositivi: '',
        commentiNegativi: '',
        altriCommenti: ''
    });

    const [notifica, setNotifica] = useState({
        aperta: false,
        messaggio: '',
        tipo: 'success'
    });

    // Gestione dei campi di input
    const gestisciCambio = (evento) => {
        const { name, value } = evento.target;
        setDatiForm({
            ...datiForm,
            [name]: value
        });
    };

    const [dopoInvioSuccesso, setDopoInvioSuccesso] = useState(false);

    // Gestione dell'invio del form
    const gestisciInvio = async (evento) => {
        if (evento) evento.preventDefault();

        try {
            // Verifica che tutti i campi obbligatori siano compilati
            if (!datiForm.coinvolgimento ||
                !datiForm.nuoveAbilita ||
                !datiForm.caricoLavoro ||
                !datiForm.istruzioniChiare ||
                !datiForm.orariLavoro ||
                !datiForm.sistemazione ||
                !datiForm.posizioneSistemazione ||
                !datiForm.trasportiLocali ||
                !datiForm.supportoOrganizzazione ||
                !datiForm.commentiPositivi ||
                !datiForm.commentiNegativi ||
                !datiForm.altriCommenti) {
                setNotifica({
                    aperta: true,
                    messaggio: 'Compila tutti i campi prima di inviare il form',
                    tipo: 'error'
                });
                return;
            }

            // Impostiamo lo stato di invio
            setCaricamento(true, 'Invio del questionario in corso...');

            // Creiamo il DTO con i dati del form
            const feedbackDTO = new FormGradimentoDTO(datiForm);
            //console.log("Test", feedbackDTO);
            
            // Inviamo i dati al server tramite il servizio
            const risposta = await formGradimentoService.salvaFeedbackIntermedio(feedbackDTO);

            // Mostriamo un messaggio di successo
            setNotifica({
                aperta: true,
                messaggio: 'Grazie per aver inviato il tuo feedback!',
                tipo: 'success'
            });

            console.log('Risposta dal server:', risposta);

            // Imposta il flag che indica il successo dell'invio, così tornerà alla homepage
            setDopoInvioSuccesso(true);

        } catch (error) {
            // Gestiamo eventuali errori
            setNotifica({
                aperta: true,
                messaggio: 'Si è verificato un errore durante l\'invio. Riprova più tardi.',
                tipo: 'error'
            });
            console.error('Errore durante l\'invio:', error);

        } finally {
            setCaricamento(false);
        }
    };

    // Chiusura del messaggio di notifica
    const chiudiNotifica = () => {
        setNotifica({
            ...notifica,
            aperta: false
        });

        // Se l'invio è stato completato con successo, naviga alla homepage
        if (dopoInvioSuccesso) {
            navigate('/homepage');
        }
    };

    // Componente per le opzioni dei radio button
    const OpzioniValutazione = ({ nome, valore }) => (
        <RadioGroup row name={nome} value={valore} onChange={gestisciCambio}>
            <FormControlLabel value="1" control={<Radio />} label="Molto in disaccordo" />
            <FormControlLabel value="2" control={<Radio />} label="Disaccordo" />
            <FormControlLabel value="3" control={<Radio />} label="Neutro" />
            <FormControlLabel value="4" control={<Radio />} label="D'accordo" />
            <FormControlLabel value="5" control={<Radio />} label="Molto d'accordo" />
        </RadioGroup>
    );

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
            <Container maxWidth="md" className="form-container">

                <Typography variant="h4" component="h1" align="center" gutterBottom className="titolo">
                    Questionario di Valutazione Intermedia
                </Typography>

                <Typography variant="subtitle1" align="center" paragraph className="sottotitolo">
                    Compila il questionario per valutare la tua esperienza Erasmus fino ad ora
                </Typography>

                <Paper elevation={3} className="paper">
                    <form onSubmit={(e) => e.preventDefault()}>
                    
                        {/* Sezione Informazioni Personali */}
                        <Box mb={4}>
                            <Typography variant="h6" gutterBottom>
                                Informazioni Generali
                            </Typography>
                            <Divider sx={{ mb: 2 }} />

                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" color="textSecondary">Nome del Partecipante</Typography>
                                    <Typography variant="body1">{datiForm.nomePartecipante || '-'}</Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">Numero Progetto</Typography>
                                    <Typography variant="body1">{datiForm.numeroProgetto || '-'}</Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">Destinazione</Typography>
                                    <Typography variant="body1">{datiForm.destinazione || '-'}</Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">Data Inizio Periodo</Typography>
                                    <Typography variant="body1">{datiForm.dataInizio || '-'}</Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">Data Fine Periodo</Typography>
                                    <Typography variant="body1">{datiForm.dataFine || '-'}</Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">Valutazione Periodo Da</Typography>
                                    <Typography variant="body1">{datiForm.dataValutazioneInizio || '-'}</Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" color="textSecondary">Valutazione Periodo A</Typography>
                                    <Typography variant="body1">{datiForm.dataValutazioneFine || '-'}</Typography>
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Sezione Valutazioni a scelta multipla */}
                        <Box mb={4}>
                            <Typography variant="h6" gutterBottom>
                                1. Per favore indica il tuo grado di accordo con quanto qui sotto riportato
                            </Typography>
                            <Divider sx={{ mb: 2 }} />

                            {/* Coinvolgimento */}
                            <Box mb={2}>
                                <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" className="etichetta-domanda">
                                        Mi sento coinvolto/a e attivamente partecipe ai task che mi sono stati assegnati
                                    </FormLabel>
                                    <OpzioniValutazione nome="coinvolgimento" valore={datiForm.coinvolgimento} />
                                </FormControl>
                            </Box>

                            {/* Nuove abilità */}
                            <Box mb={2}>
                                <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" className="etichetta-domanda">
                                        Sto acquisendo nuove abilità professionali confrontate al momento in cui ho iniziato il tirocinio
                                    </FormLabel>
                                    <OpzioniValutazione nome="nuoveAbilita" valore={datiForm.nuoveAbilita} />
                                </FormControl>
                            </Box>

                            {/* Carico di lavoro */}
                            <Box mb={2}>
                                <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" className="etichetta-domanda">
                                        Il carico di Lavoro è appropriato alle mie capacità e al tempo a disposizione
                                    </FormLabel>
                                    <OpzioniValutazione nome="caricoLavoro" valore={datiForm.caricoLavoro} />
                                </FormControl>
                            </Box>

                            {/* Istruzioni chiare */}
                            <Box mb={2}>
                                <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" className="etichetta-domanda">
                                        Ricevo istruzione chiare e dettagliate per implementare i miei task
                                    </FormLabel>
                                    <OpzioniValutazione nome="istruzioniChiare" valore={datiForm.istruzioniChiare} />
                                </FormControl>
                            </Box>

                            {/* Orari di lavoro */}
                            <Box mb={2}>
                                <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" className="etichetta-domanda">
                                        I miei orari di Lavoro sono rispettati e ben organizzati
                                    </FormLabel>
                                    <OpzioniValutazione nome="orariLavoro" valore={datiForm.orariLavoro} />
                                </FormControl>
                            </Box>

                            {/* Sistemazione abitativa */}
                            <Box mb={2}>
                                <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" className="etichetta-domanda">
                                        La sistemazione abitativa assegnatami incontra le mie aspettative in termini di qualità e comfort
                                    </FormLabel>
                                    <OpzioniValutazione nome="sistemazione" valore={datiForm.sistemazione} />
                                </FormControl>
                            </Box>

                            {/* Posizione alloggio */}
                            <Box mb={2}>
                                <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" className="etichetta-domanda">
                                        La posizione dell'alloggio è comoda rispetto alla sede del tirocinio e ai servizi essenziali
                                    </FormLabel>
                                    <OpzioniValutazione nome="posizioneSistemazione" valore={datiForm.posizioneSistemazione} />
                                </FormControl>
                            </Box>

                            {/* Trasporti locali */}
                            <Box mb={2}>
                                <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" className="etichetta-domanda">
                                        I trasporti locali per raggiungere il posto di Lavoro sono adeguati
                                    </FormLabel>
                                    <OpzioniValutazione nome="trasportiLocali" valore={datiForm.trasportiLocali} />
                                </FormControl>
                            </Box>

                            {/* Supporto organizzazione */}
                            <Box mb={2}>
                                <FormControl component="fieldset" fullWidth>
                                    <FormLabel component="legend" className="etichetta-domanda">
                                        L'organizzazione ricevente mi sta supportando efficacemente durante il periodo di tirocinio
                                    </FormLabel>
                                    <OpzioniValutazione nome="supportoOrganizzazione" valore={datiForm.supportoOrganizzazione} />
                                </FormControl>
                            </Box>
                        </Box>

                        {/* Domande aperte */}
                        <Box mb={4} sx={{ width: '100%' }}>
                            <Typography variant="h6" gutterBottom>
                                2. Cosa apprezzi di più rispetto all'azienda ospitante?
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                name="commentiPositivi"
                                value={datiForm.commentiPositivi}
                                onChange={gestisciCambio}
                                variant="outlined"
                                className="campo-commento"
                            />
                        </Box>

                        <Box mb={4} sx={{ width: '100%' }}>
                            <Typography variant="h6" gutterBottom>
                                3. Costa non ti piace rispetto all'organizzazione delle attività presso l'azienda ospitante?
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                name="commentiNegativi"
                                value={datiForm.commentiNegativi}
                                onChange={gestisciCambio}
                                variant="outlined"
                                className="campo-commento"
                            />
                        </Box>

                        <Box mb={4} sx={{ width: '100%' }}>
                            <Typography variant="h6" gutterBottom>
                                4. Altri commenti e suggerimenti
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                name="altriCommenti"
                                value={datiForm.altriCommenti}
                                onChange={gestisciCambio}
                                variant="outlined"
                                className="campo-commento"
                            />
                        </Box>
                    </form>
                </Paper>

                {/* Pulsante di invio */}
                <Box textAlign="right" mt={2}>
                    <Button
                        onClick={gestisciInvio}
                        variant="contained"
                        color="primary"
                        size="large"
                        className="pulsante-invio"
                        disabled={loading}
                    >
                        Invia Questionario
                    </Button>
                </Box>

                {/* Notifica */}
                <Snackbar
                    open={notifica.aperta}
                    autoHideDuration={10000}
                    onClose={chiudiNotifica}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert
                        onClose={chiudiNotifica}
                        severity={notifica.tipo}
                        variant="filled"
                    >
                        {notifica.messaggio}
                    </Alert>
                </Snackbar>

                {/* Spinner di caricamento */}
                <Backdrop
                    sx={{
                        color: '#ffffff',
                        zIndex: 999,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    open={loading}
                >
                    <CircularProgress
                        color="inherit"
                        size={100}
                        thickness={4}
                        style={{ marginBottom: '16px' }}
                    />
                    {messaggioCaricamento && (
                        <Typography variant="h6" component="div">
                            {messaggioCaricamento}
                        </Typography>
                    )}
                </Backdrop>
            </Container>
        </LocalizationProvider>
    );
};

export default FormGradimento;